import { topRank } from "@/mocks/chigua";

function TrendIcon({ trend }: { trend: string }) {
  if (trend === "up") {
    return <span className="inline-flex items-center gap-0.5 text-xs font-medium text-accent-700"><i className="ri-arrow-up-line"></i></span>;
  }
  if (trend === "down") {
    return <span className="inline-flex items-center gap-0.5 text-xs font-medium text-foreground-400"><i className="ri-arrow-down-line"></i></span>;
  }
  return <span className="label-cat bg-secondary-100 text-secondary-900">新</span>;
}

export default function TopRank() {
  return (
    <section id="toprank" className="container-page py-12 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
        {/* side heading */}
        <div className="lg:col-span-4">
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-primary-600">
            <i className="ri-fire-fill text-base"></i>
            TODAY TOP
          </p>
          <h2 className="section-title mt-3">今日热榜排行</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            综合讨论热度与传播速度生成当日十大关注焦点，吃瓜日报必看内容，帮你一眼锁定全网最火的话题。
          </p>
          <ul className="mt-5 space-y-2 text-sm text-foreground-700">
            {[
              ["热度实时更新", "i ri-line-chart-line"],
              ["信源多方交叉", "i ri-verified-badge-line"],
              ["每日 09:00 出刊", "i ri-calendar-check-line"],
            ].map(([t, ic]) => {
              const icon = String(ic).replace("i ", "");
              return (
                <li key={t} className="flex items-center gap-2.5">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={icon}></i>
                  </span>
                  {t}
                </li>
              );
            })}
          </ul>
          <a href="#newsletter" className="btn-ghost mt-6">
            订阅明早的热榜 <i className="ri-corner-down-right-line"></i>
          </a>
        </div>

        {/* ranking list */}
        <div className="lg:col-span-8">
          <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-100">
            <div className="flex items-center justify-between border-b border-background-200 bg-background-100 px-4 py-3 md:px-5">
              <p className="flex items-center gap-2 text-sm font-semibold text-foreground-800">
                <i className="ri-donut-chart-fill text-accent-600"></i>
                全站热点榜 · TOP 10
              </p>
              <span className="flex items-center gap-1.5 text-xs text-foreground-500">
                <span className="flex h-2 w-2">
                  <span className="absolute inline-flex h-2 w-2 animate-ping rounded-full bg-primary-400 opacity-75"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
                </span>
                热度实时
              </span>
            </div>
            <ol>
              {topRank.map((item, idx) => (
                <li
                  key={item.rank}
                  className={`flex items-center gap-3 px-4 py-3.5 transition hover:bg-background-50 md:gap-4 md:px-5 ${
                    idx < topRank.length - 1 ? "border-b border-background-200/70" : ""
                  }`}
                >
                  <span
                    className={`w-7 shrink-0 text-center font-display text-xl font-black ${
                      idx === 0
                        ? "text-primary-500"
                        : idx === 1
                          ? "text-accent-600"
                          : idx === 2
                            ? "text-secondary-600"
                            : "text-foreground-300"
                    }`}
                  >
                    {item.rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <a
                      href="#featured"
                      className="line-clamp-2 text-sm font-medium text-foreground-800 transition hover:text-primary-600 md:text-[15px]"
                    >
                      {item.title}
                    </a>
                    <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                      <span className="label-cat bg-secondary-100 text-secondary-900">{item.category}</span>
                      <span className="flex items-center gap-1"><i className="ri-fire-line"></i>{item.heat}</span>
                    </div>
                  </div>
                  <TrendIcon trend={item.trend} />
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}